import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../lib/api.jsx";

const NAV = [
  ["/", "Dashboard"],
  ["/users", "Subscribers"],
  ["/verify", "Verification"],
  ["/packages", "Packages"],
  ["/subscriptions", "Subscriptions"],
  ["/payments", "Payments"],
  ["/portals", "Portals"],
  ["/permissions", "Permissions"],
  ["/logins", "User logins"],
  ["/activity", "Activity"],
  ["/notifications", "Notifications"],
  ["/partners", "Partner overview"],
  ["/files", "File overview"],
  ["/audit", "Admin audit"],
  ["/trash", "Trash"],
];

export default function Layout() {
  const { api, name, logout, toast } = useAuth();
  const [meta, setMeta] = useState({});
  const [navOpen, setNavOpen] = useState(false);
  const [openGroups, setOpenGroups] = useState({});
  const location = useLocation();

  useEffect(() => { api("t_meta").then(setMeta).catch(() => {}); }, [api]);
  // Close the mobile drawer on every navigation so a tap doesn't leave it open.
  useEffect(() => { setNavOpen(false); }, [location.pathname]);
  // Auto-expand whichever dropdown section contains the page the user is on,
  // so landing on /ref/region (say) via a direct link doesn't hide it in a
  // collapsed section.
  useEffect(() => {
    if (!location.pathname.startsWith("/ref/")) return;
    const key = location.pathname.slice(5);
    const g = meta[key]?.g;
    if (g) setOpenGroups((o) => (o[g] ? o : { ...o, [g]: true }));
  }, [location.pathname, meta]);

  const groups = {};
  Object.entries(meta).forEach(([key, m]) => (groups[m.g] ??= []).push([`/ref/${key}`, m.title]));
  const toggleGroup = (g) => setOpenGroups((o) => ({ ...o, [g]: !o[g] }));

  return (
    <div className="app">
      <div className="topbar">
        <button className="hamburger" aria-label="Open menu" aria-expanded={navOpen} onClick={() => setNavOpen((v) => !v)}>
          <span /><span /><span />
        </button>
        <span className="brand">Ghorami Admin</span>
      </div>
      <div className={"scrim" + (navOpen ? " open" : "")} onClick={() => setNavOpen(false)} />
      <aside className={navOpen ? "open" : ""}>
        <h1>Ghorami Admin</h1>
        {/* Independent scroll region: the header above and sign-out below stay put. */}
        <nav className="nav-scroll">
          {NAV.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => (isActive ? "on" : "")}>
              {label}
            </NavLink>
          ))}
          {Object.entries(groups).map(([g, items]) => {
            const open = !!openGroups[g];
            const hasActive = items.some(([to]) => location.pathname === to);
            return (
              <div className="nav-group" key={g}>
                <button
                  type="button"
                  className={"nav-group-btn" + (hasActive ? " on" : "")}
                  aria-expanded={open}
                  onClick={() => toggleGroup(g)}
                >
                  <span className="nav-group-label">{g}</span>
                  <span className={"chev" + (open ? " open" : "")} aria-hidden="true">›</span>
                </button>
                {open && (
                  <div className="nav-group-items">
                    {items.map(([to, label]) => (
                      <NavLink key={to} to={to} className={({ isActive }) => (isActive ? "on" : "")}>{label}</NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>
        <button className="signout-btn" onClick={logout}>Sign out{name ? ` (${name})` : ""}</button>
      </aside>
      <main>
        <Outlet />
      </main>
      {toast && <div className="toast" role="status">{toast}</div>}
    </div>
  );
}
